import ExamSectionTemplate from '@/pages/ExamSectionTemplate';

const faqs = [
  {
    question: "What is CBELM certification?",
    answer: "CBELM (Competency-Based Examination in Longevity Medicine) validates clinical competency in longevity, anti-aging, and functional medicine. It assesses hormonal optimisation, metabolic medicine, preventive protocols, and evidence-based approaches to healthy ageing."
  },
  {
    question: "Who should pursue CBELM certification?",
    answer: "CBELM is designed for licensed medical practitioners who practice or wish to specialize in longevity medicine, anti-aging therapies, hormone replacement therapy, metabolic optimization, and preventive health protocols."
  },
  {
    question: "What clinical domains does CBELM cover?",
    answer: "CBELM assesses competency in hormone optimization (including testosterone, thyroid, growth hormone), metabolic medicine, preventive medicine protocols, nutrition and lifestyle interventions, and comprehensive risk stratification."
  },
  {
    question: "How is the CBELM examination structured?",
    answer: "CBELM includes a Clinical Reasoning Written Examination, Case-Based OSCE with patient scenarios, Hormonal & Metabolic Case Discussion evaluating treatment protocols, and a Viva Examination assessing clinical reasoning and evidence appraisal."
  },
  {
    question: "What is the difference between CBELM and CBERM?",
    answer: "CBELM focuses on longevity, anti-aging, and hormonal optimization using established medical interventions. CBERM (Regenerative Medicine) focuses on cellular therapies, stem cells, and regenerative interventions. Some practitioners pursue both certifications."
  },
  {
    question: "Are there regulatory considerations for longevity medicine practice?",
    answer: "Yes, longevity medicine practices must comply with local regulatory frameworks regarding hormone therapies and anti-aging interventions. CBELM certification validates competency but practitioners must ensure their practice aligns with jurisdictional regulations."
  }
];

export default function LongevityMedicinePage() {
  return (
    <ExamSectionTemplate
      sectionTitle="Section 2: Longevity & Anti-Aging Medicine"
      examCode="CBELM"
      ipcfBadge="Level 6 Practitioner Certification"
      examFullName="Competency-Based Examination in Longevity Medicine"
      testIdPrefix="cbelm"
      fee="₹35,000"
      faqs={faqs}
      overview="CBELM assesses clinical competency in longevity, anti-aging, and functional medicine. The examination evaluates hormonal optimisation, metabolic medicine, preventive protocols, and evidence-based approaches to healthy ageing. This certification is designed for licensed medical practitioners seeking to validate their competency in this growing specialty."
      eligibility={[
        'Valid medical registration in home jurisdiction',
        'Minimum 2 years post-licensure clinical experience',
        'Evidence of training or practice in longevity/anti-aging medicine',
        'Professional references from two registered medical practitioners',
        'Compliance with IMCAC ethics and conduct standards',
        'Current professional indemnity insurance',
      ]}
      stages={[
        { title: 'Clinical Reasoning Written Examination', desc: 'Written assessment testing clinical knowledge in hormonal, metabolic, and functional medicine.' },
        { title: 'Case-Based OSCE', desc: 'Structured clinical examination with patient scenarios in longevity medicine practice.' },
        { title: 'Hormonal & Metabolic Case Discussion', desc: 'Case-based assessment of hormonal optimisation and metabolic management protocols.' },
        { title: 'Viva Examination', desc: 'Oral examination assessing clinical reasoning, evidence appraisal, and ethical practice.' },
      ]}
      coreDomains={[
        'Hormone Optimization',
        'Metabolic Medicine',
        'Preventive Medicine',
        'Nutrition & Lifestyle',
        'Risk Stratification',
      ]}
      certificationValidity={[
        'Initial certification valid for 5 years from date of issue',
        'Certificate verifiable through IMCAC public verification portal',
        'Certification title: Board Certified in Longevity Medicine (IMCAC – CBELM)',
        'Certification may be revoked for non-compliance with CPD or ethics requirements',
      ]}
      recertificationPolicy={[
        'Recertification required every 5 years',
        'Minimum 25 CPD hours per year in relevant longevity medicine activities',
        'Evidence of continued clinical practice in the specialty',
        'Compliance audit by IMCAC CPD Committee',
        'Non-compliance may result in suspension of certification status',
      ]}
      disclaimer="Certification validates assessed competencies within longevity and anti-aging medicine and does not grant medical licensure. Candidates must hold valid professional registration in their jurisdiction. Assistant certification is support-level only and does not confer independent practice rights."
      applyLink="/apply"
    />
  );
}
